<template>
	<router-link class="block whitespace-nowrap px-1.5 py-2 text-xs text-gray-500 sm:px-3 sm:py-3.5 md:text-sm">
		<slot />
	</router-link>
</template>
